import React from "react";

const TextInput = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    error,
    baseinfo,
    defaultValue,
  } = props;

  return (
    <div className={`my-4 ${containerCls}`}>
      {label ? <div className="pb-1 text-gray-800">{label}</div> : null}

      <input
        type="text"
        className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full ${
          error ? "" : ""
        }`}
        defaultValue={defaultValue}
        value={defaultValue}
        {...inputProps}
      />
      {baseinfo ? <div className="pb-1 text-gray-800">{baseinfo}</div> : null}
      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default TextInput;
